import logo from '~/assets/images/logo.svg';
import logo2 from '~/assets/images/logo-2.svg';
import fiotecLogoFinal from '~/assets/images/Fiotec-logo_Final.svg'
const images = {
  logo,
  logo2,
  fiotecLogoFinal
};

export default images;
